export const ADOBE_ANALYTICS = 'adobeAnalytics';
export const ROYALTY_REPORTING = 'ROYALTY_REPORTING';
